import { getAuth } from 'firebase/auth';

/**
 * Get the current Firebase authentication token
 * @returns Promise<string> The authentication token
 * @throws Error if user is not authenticated
 */
export const getAuthToken = async (): Promise<string> => {
  const auth = getAuth();
  const user = auth.currentUser;
  
  if (!user) {
    throw new Error('User not authenticated');
  }
  
  try {
    const token = await user.getIdToken();
    return token;
  } catch (error) {
    console.error('Error getting auth token:', error);
    throw new Error('Failed to get authentication token');
  }
};

/**
 * Get authenticated headers for API requests
 * @returns Promise<Record<string, string>> Headers object with authentication
 */
export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

